import React, { useEffect, useState } from "react";
import "./Sidebar.css";
// import EmployeeDHSvg from '../../../../assets/Side Bar/Super Admin/dark Mode/em';

import SidebarListItem from './SidebarListItem';
import { IconButton } from '@mui/material';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import TaskVerification from "../../../../assets/Icons/sidebar/Task Verification _ normal.svg";

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import {
  setActiveItem,
} from '../../../../redux-toolkit/features/theme/themeSlice';
import { Transition } from 'react-transition-group';
import { useGetInitialAppliedThemeQuery } from '../../../../redux-toolkit/features/theme/themeApiSlice';

const duration = 500;
const sidebarStyle = {
  transition: `width ${duration}ms ease`,
};
const sidebarTransitionStyles = {
  entering: { width: '52px' },
  entered: { width: '270px' },
  exiting: { width: '270px' },
  exited: { width: '52px' },
};

const opacitySwitchTransitionStyles = {
  entering: { opacity: 0, width: 0, height: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0, width: 0, height: 0 },
};

const sidebarLinksWidthTransitionStyles = {
  entering: { width: '50%' },
  entered: { width: '85%' },
  exiting: { width: '85%' },
  exited: { width: '42%' },
};

const opacityArrowTransitionStyles = {
  entering: { transform: 'rotate(0)' },
  entered: { transform: 'rotate(180deg)' },
  exiting: { transform: 'rotate(180deg)' },
  exited: { transform: 'rotate(0)' },
};

export const Sidebar = ({ open, handleSidebar, sideBarAdmin }) => {
  // const [activeItem, setActiveItem] = useState(sideBarAdmin[0].id);
  const { pathname } = useLocation();
  const { data } = useGetInitialAppliedThemeQuery({
    refetchOnMountOrArgChange: true,
  });
  const { activeItem } = useSelector((state) => state.theme);
  const [activeOrg, setActiveOrg] = useState(false);
  const [activeQuest, setActiveQuest] = useState(false);
  const [activeRewards, setActiveRewards] = useState(false);
  const [activePromotions, setActivePromotions] = useState(false);
  const [activeCompany, setActiveCompany] = useState(false);
  const dispatch = useDispatch();
  function onClick(id) {
    dispatch(setActiveItem(id));
  }

  useEffect(()=>{
    if(pathname.includes("/admin/manage-company")){
      dispatch(setActiveItem(3))
      setActiveCompany(true)
      setActiveOrg(false);
      setActiveQuest(false);
      setActiveRewards(false)
      setActivePromotions(false)
    }else if(pathname.includes("/super-admin/manage-organization/companies")){
      dispatch(setActiveItem(2))
      setActiveCompany(false)
      setActiveOrg(true);
      setActiveQuest(false);
      setActiveRewards(false)
      setActivePromotions(false)
    }else if(pathname.includes("/super-admin/manage-organization/task-verification")){
      dispatch(setActiveItem(3))
      setActiveCompany(false)
      setActiveOrg(false);
      setActiveQuest(true);
      setActiveRewards(false)
      setActivePromotions(false)
    }else if(pathname.includes("/super-admin/promotions")){
      setActivePromotions(true)
      setActiveRewards(false)
      setActiveOrg(false)
      setActiveQuest(false)
      setActiveCompany(false)
    }
  },[])

  return (
    <div className="sidebar__layout">
      <Transition
        in={open}
        timeout={150}>
        {(state) => (
          <>
            <div className="sidebar__switch">
              <IconButton
                onClick={handleSidebar}
                aria-label="sidebar-switch"
                size="small">
                <ArrowForwardIosIcon
                  sx={{
                    color: 'white',
                    strokeWidth: 1,
                    stroke: 'white',
                    transition: `transform ${duration}ms  `,
                  }}
                  style={{ ...opacityArrowTransitionStyles[state] }}
                  fontSize="inherit"
                />
              </IconButton>
            </div>
            <div
              className="sidebar"
              style={{
                ...sidebarStyle,
                ...sidebarTransitionStyles[state],
              }}>
              <div>
                <div
                  className="sidebar__logo"
                  style={{
                    ...opacitySwitchTransitionStyles[state],
                  }}>
                  {/* {theme ? <img src={logo} alt="" /> : <img src={whiteLogo} alt="" />} */}
                </div>

                <div className="sidebar__content">
                  <div
                    className="sidebar__links"
                    style={{
                      ...sidebarLinksWidthTransitionStyles[state],
                      ...sidebarStyle,
                    }}>
                    <ul>
                      {sideBarAdmin.map((listItem) => {
                        return (
                          <SidebarListItem
                            activeOrg={activeOrg}
                            setActiveOrg={setActiveOrg}
                            activeQuest={activeQuest}
                            setActiveQuest={setActiveQuest}
                            activeRewards={activeRewards}
                            setActiveCompany={setActiveCompany}
                            activeCompany={activeCompany}
                            setActiveRewards={setActiveRewards}
                            activePromotions={activePromotions}
                            setActivePromotions={setActivePromotions}
                            theme={data?.data.mode}
                            key={listItem.id}
                            active={activeItem === listItem.id}
                            onClick={onClick}
                            access={listItem.access}
                            open={open}
                            handleSidebar={handleSidebar}
                            {...listItem}
                          />
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Transition>
    </div>
  );
};
